export default class Cookies {
  constructor() {
    const button = document.getElementById("manage-cookies")
    button.addEventListener("click", () => {
      const banner = document.querySelector("cookie-banner")

      if (banner) {
        banner.promptForConsent()
      }
    })
  }
}
